import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-objectentable',
  templateUrl: './objectentable.component.html',
  styleUrls: ['./objectentable.component.less']
})
export class ObjectentableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
